export const ChannelStatus = {
	ACTIVE: 'ACTIVE',
	DISABLED: 'DISABLED',
	SUSPENDED: 'SUSPENDED',
};
